import { gql } from "@apollo/client";

const schema = {
  create: {
    name: "createPlan",
    serviceName: "admin",
    query: gql`
      mutation createPlan(
        $title: String!
        $related_to: String # labratoar < ,unit
        $validity_months: String
        # $quantity: String
        # $order_quantity: String
        $lab_quantity: String
        $unit_quantity: String
        $doctor_quantity: String
        # $agreement_quantity: String
        $amount: String
        $code: String
        $details: String
      ) {
        createPlan(
          title: $title
          related_to: $related_to
          validity_months: $validity_months
          # quantity: $quantity
          # order_quantity: $order_quantity
          lab_quantity: $lab_quantity
          unit_quantity: $unit_quantity
          doctor_quantity: $doctor_quantity
          # agreement_quantity: $agreement_quantity
          amount: $amount
          code: $code
          details: $details
        ) {
          messages
        }
      }
    `,
  },
};

export default schema;
